
function updateHeader() {
  var header = document.getElementById('SiteHeader');

  if (!header) return;

  if (window.scrollY > 50) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', updateHeader);

// Run on scroll
document.addEventListener('scroll', updateHeader);

// Run again after everything is loaded (helps when browser restores scroll position)
window.addEventListener('load', updateHeader);

  document.addEventListener('DOMContentLoaded', function () {
 
    var btn = document.getElementById('hamburgerBtn');
    var menu = document.getElementById('mobileMenu');
    var overlay = document.getElementById('menuOverlay');
    var closeBtn = document.getElementById('menuCloseBtn'); 

    if (btn && menu && overlay) {
      btn.addEventListener('click', function () {
        menu.classList.toggle('active');
        overlay.classList.toggle('active');
      });

      overlay.addEventListener('click', function () {
        menu.classList.remove('active');
        overlay.classList.remove('active');
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          menu.classList.remove('active');
          overlay.classList.remove('active');
        });
      }
    }
    // var dropParents = document.querySelectorAll('.has-dropdown');

    // dropParents.forEach(function (parent) {
    //   var mainLink = parent.querySelector('.nav-link');
    //   if (mainLink) {
    //     mainLink.addEventListener('click', function (e) {
    //       e.preventDefault();
    //       e.stopPropagation();

    //       dropParents.forEach(function (otherParent) {
    //         if (otherParent !== parent) {
    //           otherParent.classList.remove('dropdown-open');
    //         }
    //       });

    //       parent.classList.toggle('dropdown-open');
    //     });
    //   }
    // });

    // document.addEventListener('click', function (e) {
    //   if (!e.target.closest('.has-dropdown')) {
    //     dropParents.forEach(function (parent) {
    //       parent.classList.remove('dropdown-open');
    //     });
    //   }
    // });
  });


(function () {
  function measureMobileHeader() {
    const header = document.getElementById('SiteHeader');
    if (!header) return;
    const measure = function () {
      const style = getComputedStyle(header);
      const height = style.position === 'fixed' ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--kti-mobile-header-height', Math.ceil(height) + 'px');
    };
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(header);
    window.addEventListener('resize', measure);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measureMobileHeader);
  else measureMobileHeader();
})();
